<template>
  <div class="shipment">
    <div
      class="shipment-head--title black--text font-weight-medium"
      :class="{ 'fs-18': breakpointXs, 'fs-25': !breakpointXs }"
    >
      <DashboardBreadcrumb :items="breadCrumbItems" />
    </div>
    <div class="shipment-body mt-4">
      <v-card elevation="4" class="px-8 py-6">
        <div class="shipment-body--title fw-600" :class="{ 'fs-18': breakpointXs, 'fs-25': !breakpointXs }">
          <span>Shipment Details</span>
          <span>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn @click="makeFieldsNull" class="float-right" color="blue-grey" v-on="on">
                  <span class="font-weight-bold white--text ">Reset</span>
                  <v-icon class="font-weight-bold white--text fs-15 ml-2">fas fa-undo</v-icon>
                </v-btn>
              </template>
              {{ resetIconMessage() }}
            </v-tooltip>
          </span>
        </div>
        <div class="shipment-body__tab mt-6 mb-6">
          <v-tabs v-model="tab">
            <v-tab v-for="item in tabHeaders" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <MainShipmentTab
                :resetShipment="isResetShipment"
                @clear-reset-shipment="isResetShipment = false"
                @change-tab="changeTab"
              />
            </v-tab-item>
            <!-- <v-tab-item>
              <SBDetailsTab @change-tab="changeTab" />
            </v-tab-item> -->
            <v-tab-item>
              <PackagingDetailsTab @change-tab="changeTab" />
            </v-tab-item>
            <!-- <v-tab-item>
              <OtherDetailsTab @change-tab="changeTab" />
            </v-tab-item> -->
          </v-tabs-items>
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import DashboardBreadcrumb from "@/modules/DashboardModule/components/DashboardBreadcrumb";
import MainShipmentTab from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/pages/MainShipmentTab";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
// import SBDetailsTab from "./SBDetailsTab";
import PackagingDetailsTab from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/pages/PackagingDetailsTab";
// import OtherDetailsTab from "./OtherDetailsTab";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "Shipment",
  components: {
    DashboardBreadcrumb,
    MainShipmentTab,
    // SBDetailsTab,
    PackagingDetailsTab
    // OtherDetailsTab
  },
  data() {
    return {
      tab: null,
      isResetShipment: false,
      isResetPackingList: false
    };
  },
  mixins: [commonMethodsMixin],
  methods: {
    changeTab(val) {
      this.tab = val;
    },
    makeFieldsNull() {
      const value = null;
      this.$store.commit(MT.SET_PACKING_LIST_PACKING_NO_FROM, { value });
      this.$store.commit(MT.SET_PACKING_LIST_PACKING_NO_TO, { value });
      this.$store.commit(MT.SET_PACKING_LIST_PACKING_CODE, { value });
      this.isResetShipment = true;
    }
  },
  computed: {
    tabHeaders() {
      //   return ["Main", "SB Details", "Packaging Details", "Other Details"];
      return ["Main", "Packaging Details"];
    },
    breadCrumbItems() {
      return [
        {
          title: "Dashboard",
          route: "dashboard.home",
          children: [
            {
              title: "Export",
              route: "dashboard.export",
              children: [
                {
                  title: "Shipment",
                  route: "dashboard.export.shipment"
                }
              ]
            }
          ]
        }
      ];
    }
  }
};
</script>
<style lang="scss">
@import "../../../../../../../styles/settings/index";

.shipment-body__tab {
  .v-tabs {
    padding: 0 0.5rem;
    .v-item-group.v-tabs-bar {
      background: transparent;
      .v-slide-group__wrapper {
        .v-tabs-slider-wrapper {
          height: 5px !important;
        }
        .v-tab {
          color: $brand-dark-grey;
        }
        .v-tab.v-tab--active {
          color: black;
        }
      }
    }
  }
  .theme--light.v-item-group.v-tabs-items {
    background: transparent;
    border: solid 2px $brand-dark-grey;
    border-radius: 5px;
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.06);
    .theme--light.v-card {
      background: transparent;
    }
  }
}
</style>
